import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

const prodottiMiglioriJsonLd = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Article',
      '@id': 'https://itaobuyspread.top/prodotti-migliori-itaobuy/#article',
      headline: 'I 10 Migliori Prodotti Trovati con Itaobuy Spreadsheet nel 2026',
      description: 'La top 10 dei migliori prodotti fashion trovati con Itaobuy Spreadsheet: sneakers, abbigliamento, accessori e profumi recensiti dalla community italiana.',
      image: 'https://readdy.ai/api/search-image?query=Top%20ten%20luxury%20fashion%20products%20arranged%20in%20an%20elegant%20grid%20on%20warm%20cream%20marble%20surface%2C%20sneakers%20leather%20bags%20watches%20and%20accessories%2C%20soft%20natural%20window%20lighting%2C%20Mediterranean%20luxury%20aesthetic%2C%20warm%20terracotta%20and%20gold%20tones%2C%20editorial%20product%20photography%2C%20each%20item%20beautifully%20styled%2C%20clean%20minimal%20composition%20with%20gentle%20shadows%2C%20high%20end%20catalog%20shot&width=1200&height=600&seq=prodotti-hero&orientation=landscape',
      author: { '@type': 'Organization', name: 'Itaobuy Team', url: 'https://itaobuyspread.top' },
      publisher: { '@id': 'https://itaobuyspread.top/#organization' },
      mainEntityOfPage: { '@type': 'WebPage', '@id': 'https://itaobuyspread.top/prodotti-migliori-itaobuy' },
      datePublished: '2026-07-14',
      dateModified: '2026-07-14',
      inLanguage: 'it',
      isPartOf: { '@id': 'https://itaobuyspread.top/#website' },
    },
    {
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: 'Home', item: 'https://itaobuyspread.top' },
        { '@type': 'ListItem', position: 2, name: 'Migliori Prodotti', item: 'https://itaobuyspread.top/prodotti-migliori-itaobuy' },
      ],
    },
  ],
};

export default function ProdottiMiglioriPage() {
  return (
    <>
      <Navbar />
      <main>
        <article>
          <header className="pt-32 pb-16 md:pt-40 md:pb-20 px-6 md:px-10 bg-background-50">
            <div className="max-w-4xl mx-auto text-center">
              <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100/80 text-accent-800 text-xs font-semibold tracking-wide uppercase mb-5">
                Top 10 Prodotti
              </span>
              <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-foreground-950 leading-tight mb-6">
                I 10 Migliori Prodotti Trovati con Itaobuy Spreadsheet nel 2026
              </h1>
              <div className="flex items-center justify-center gap-4 text-sm text-foreground-500">
                <span>Da Itaobuy Team</span>
                <span className="w-1 h-1 rounded-full bg-foreground-300"></span>
                <span>Aggiornato: Luglio 2026</span>
                <span className="w-1 h-1 rounded-full bg-foreground-300"></span>
                <span>15 min di lettura</span>
              </div>
            </div>
          </header>

          <div className="max-w-4xl mx-auto px-6 md:px-10">
            <div className="mb-12 overflow-hidden rounded-[32px]">
              <img
                src="https://readdy.ai/api/search-image?query=Top%20ten%20luxury%20fashion%20products%20arranged%20in%20an%20elegant%20grid%20on%20warm%20cream%20marble%20surface%2C%20sneakers%20leather%20bags%20watches%20and%20accessories%2C%20soft%20natural%20window%20lighting%2C%20Mediterranean%20luxury%20aesthetic%2C%20warm%20terracotta%20and%20gold%20tones%2C%20editorial%20product%20photography%2C%20each%20item%20beautifully%20styled%2C%20clean%20minimal%20composition%20with%20gentle%20shadows%2C%20high%20end%20catalog%20shot&width=1200&height=600&seq=prodotti-hero&orientation=landscape"
                alt="I migliori prodotti trovati con Itaobuy Spreadsheet"
                title="Itaobuy Spreadsheet - Migliori Prodotti 2026"
                className="w-full aspect-[2/1] object-cover object-top"
              />
            </div>

            <div className="prose prose-lg max-w-none mb-16">
              <section className="mb-14">
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-5">
                  Come Abbiamo Selezionato i Migliori Prodotti
                </h2>
                <p className="text-foreground-700 leading-relaxed mb-4">
                  Il nostro team ha analizzato <strong>centinaia di prodotti</strong> presenti su Itaobuy Spreadsheet per identificare quelli che offrono il miglior rapporto qualit&agrave;-prezzo. Ogni prodotto &egrave; stato valutato in base a quattro criteri fondamentali: <strong>qualit&agrave; delle foto QC</strong>, <strong>valutazione del venditore</strong>, <strong>rapporto qualit&agrave;-prezzo</strong> e <strong>feedback della community</strong>.
                </p>
                <p className="text-foreground-700 leading-relaxed">
                  <Link to="/" className="text-primary-600 font-semibold hover:text-primary-700 underline underline-offset-4">
                    Torna alla homepage di Itaobuy Spreadsheet
                  </Link> per esplorare tutte le categorie.
                </p>
              </section>

              <div className="my-12 p-8 rounded-[28px] bg-secondary-100/50 border border-secondary-200/50 text-center">
                <h3 className="font-heading text-xl font-bold text-foreground-950 mb-3">
                  Vuoi Vedere Tutti i Prodotti?
                </h3>
                <p className="text-foreground-600 mb-5 text-sm">
                  Accedi allo spreadsheet completo con migliaia di articoli verificati.
                </p>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-primary-500 text-sm font-semibold text-background-50 hover:bg-primary-600 transition-all cursor-pointer whitespace-nowrap"
                >
                  Vai a Itaobuy Sheet
                  <i className="ri-arrow-right-up-line"></i>
                </a>
              </div>

              <section className="mb-14">
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-5">
                  La Top 10 dei Prodotti
                </h2>
                <div className="space-y-6">
                  {[
                    { name: 'Sneakers Premium Edition', cat: 'Scarpe', rating: '4.9', price: '€45-65', note: 'Design esclusivo con materiali di prima qualit&agrave;. Le foto QC mostrano una finitura impeccabile e dettagli curati.' },
                    { name: 'Hoodie in Cotone Organico', cat: 'Felpe/Maglioni', rating: '4.8', price: '€25-38', note: 'Tessuto morbido e resistente. Disponibile in 12 colori. Le recensioni lodano la vestibilit&agrave; perfetta.' },
                    { name: 'T-Shirt Minimal Collection', cat: 'T-Shirt', rating: '4.7', price: '€12-20', note: 'Cotone pesante 220gsm, stampa di alta qualit&agrave;. Taglio moderno e versatile per ogni occasione.' },
                    { name: 'Giacca Invernale Tecnica', cat: 'Giacche', rating: '4.8', price: '€55-85', note: 'Impermeabile e traspirante, ideale per l&apos;inverno italiano. Cuciture rinforzate e zip YKK.' },
                    { name: 'Pantaloni Chino Slim Fit', cat: 'Pantaloni/Corti', rating: '4.6', price: '€28-42', note: 'Tessuto elasticizzato di alta gamma. Vestibilit&agrave; slim moderna e confortevole.' },
                    { name: 'Cappellino Urban Style', cat: 'Copricapi', rating: '4.5', price: '€8-15', note: 'Design urbano con ricamo di precisione. Chiusura regolabile e materiali traspiranti.' },
                    { name: 'Set Coordinato Sport', cat: 'Set', rating: '4.7', price: '€40-60', note: 'Completo sportivo con tessuto tecnico. Perfetto per allenamento e tempo libero.' },
                    { name: 'Borsa in Pelle Vintage', cat: 'Borse', rating: '4.9', price: '€70-110', note: 'Pelle pieno fiore con finitura artigianale. Interno organizzato con tasche multiple.' },
                    { name: 'Cintura in Cuoio Italiano', cat: 'Cinture', rating: '4.6', price: '€18-30', note: 'Cuoio pieno fiore con fibbia in metallo satinato. Disponibile in 4 larghezze diverse.' },
                    { name: 'Profumo Unisex Orientale', cat: 'Profumi', rating: '4.5', price: '€22-35', note: 'Fragranza ispirata ai profumi di nicchia. Note di testa agrumate con base legnosa persistente.' },
                  ].map((product, i) => (
                    <div key={i} className="p-6 rounded-2xl bg-background-50 border border-background-200/60">
                      <div className="flex items-start gap-4">
                        <div className="flex-shrink-0 w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center">
                          <span className="text-primary-600 font-bold text-sm">{i + 1}</span>
                        </div>
                        <div className="flex-1">
                          <div className="flex flex-wrap items-center gap-3 mb-2">
                            <h3 className="font-heading font-bold text-foreground-950 text-lg">{product.name}</h3>
                            <span className="text-xs px-2 py-1 rounded-full bg-accent-100 text-accent-700">{product.cat}</span>
                          </div>
                          <div className="flex items-center gap-4 mb-2">
                            <div className="flex items-center gap-1">
                              {[...Array(5)].map((_, j) => (
                                <i key={j} className={`ri-star-fill text-xs ${j < Math.floor(Number(product.rating)) ? 'text-accent-500' : 'text-foreground-200'}`}></i>
                              ))}
                              <span className="text-xs font-semibold text-foreground-700 ml-1">{product.rating}</span>
                            </div>
                            <span className="text-xs font-semibold text-primary-600">{product.price}</span>
                          </div>
                          <p className="text-sm text-foreground-600 leading-relaxed">{product.note}</p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </section>

              <section className="mb-14">
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-5">
                  Conclusione
                </h2>
                <p className="text-foreground-700 leading-relaxed mb-4">
                  Questi dieci prodotti rappresentano il meglio che Itaobuy Spreadsheet ha da offrire nel 2026. Ogni articolo &egrave; stato <strong>verificato personalmente</strong> dal nostro team e ha ricevuto valutazioni eccezionali dalla community italiana.
                </p>
                <p className="text-foreground-700 leading-relaxed">
                  <Link to="/" className="text-primary-600 font-semibold hover:text-primary-700 underline underline-offset-4">
                    Esplora la homepage di Itaobuy Spreadsheet
                  </Link> per scoprire tutte le categorie disponibili.
                </p>
              </section>
            </div>

            <div className="mb-20 p-8 rounded-[28px] bg-primary-500 text-center">
              <h3 className="font-heading text-2xl font-bold text-background-50 mb-3">
                Scopri Tutti i Prodotti Verificati
              </h3>
              <p className="text-primary-100 mb-6 max-w-lg mx-auto">
                Accedi allo spreadsheet completo e trova il prodotto perfetto per te.
              </p>
              <div className="flex flex-col sm:flex-row items-center gap-4 justify-center">
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-background-50 text-sm font-semibold text-primary-600 hover:bg-background-100 transition-all cursor-pointer whitespace-nowrap"
                >
                  Itaobuy Sheet
                  <i className="ri-arrow-right-up-line"></i>
                </a>
                <Link
                  to="/"
                  className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-primary-600 text-sm font-semibold text-background-50 hover:bg-primary-700 transition-all cursor-pointer whitespace-nowrap"
                >
                  Homepage
                  <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            </div>
          </div>

          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: JSON.stringify(prodottiMiglioriJsonLd),
            }}
          />
        </article>
      </main>
      <Footer />
    </>
  );
}